import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, LanguagesIcon } from "lucide-react";
import { useWords } from "../../contexts/WordsContext";
import type { Course } from "../../types/learning";
import { BrutalButton } from "../ui/BrutalButton";
import { practicePath, wordsPath } from "../../utils/routes";
interface MyWordsPanelProps {
  course: Course;
}
export function MyWordsPanel({
  course
}: MyWordsPanelProps) {
  const {
    words,
    dueWords
  } = useWords();
  const courseWords = words.filter(w => w.courseId === course.id);
  const due = dueWords(course.id);
  const fromTranslator = courseWords.filter(w => w.source === "translator").slice(0, 3);
  const counts = {
    new: courseWords.filter(w => w.status === "new").length,
    practising: courseWords.filter(w => w.status === "practising").length,
    mastered: courseWords.filter(w => w.status === "mastered").length
  };
  return <section aria-labelledby="mywords-title" className="rounded-card border-3 border-line bg-mint p-5 shadow-brutal-sm" data-id="element-182" data-mp="2q348z4nqb0qu">
      <div className="flex items-start justify-between gap-3" data-id="element-183" data-mp="22wr0s41uipfr">
        <div data-id="element-184" data-mp="27v27w70ralua">
          <h2 id="mywords-title" className="text-sm font-bold text-ink-2" data-id="element-185" data-mp="27usjgnvd0mqp">
            My Words
          </h2>
          <p className="mt-1 text-[32px] font-bold leading-none tracking-[-0.02em] text-ink" data-id="element-186" data-mp="2crsm0ot037d2">
            {due.length}
            <span className="ml-2 text-base font-semibold text-ink-2" data-id="element-187" data-mp="2hpu5hauc98p2">due today</span>
          </p>
        </div>
        <Link to={wordsPath(course)} className="focus-ring rounded-lg p-1.5 text-ink-2 hover:text-ink" aria-label="Open My Words" data-id="element-188" data-mp="2qsv994vqenpk">
          <ArrowRightIcon className="h-5 w-5" data-id="element-189" data-mp="2vjbrd2ahyxi9" />
        </Link>
      </div>

      <dl className="mt-4 flex gap-4 text-sm" data-id="element-190" data-mp="30iew0lmkf1pp">
        {(["new", "practising", "mastered"] as const).map(k => <div key={k} data-id="element-191" data-mp="35ikebb6y3bv4">
            <dt className="capitalize text-ink-2" data-id="element-192" data-mp="35j2h6qo44oc0">{k}</dt>
            <dd className="font-bold text-ink" data-id="element-193" data-mp="39j37b8kkqnyw">{counts[k]}</dd>
          </div>)}
      </dl>

      {fromTranslator.length > 0 && <div className="mt-4" data-id="element-194" data-mp="1afebbdjjvpms">
          <p className="flex items-center gap-1.5 text-xs font-semibold text-ink-2" data-id="element-195" data-mp="1aci8pbwrccs0">
            <LanguagesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-196" data-mp="15hcrgqeavma9" /> Recently saved from translator
          </p>
          <ul className="mt-2 flex flex-wrap gap-1.5" data-id="element-197" data-mp="1j8rct3vojzkh">
            {fromTranslator.map(w => <li key={w.id} className="rounded-lg bg-surface/80 px-2 py-1 text-xs font-semibold text-ink" title={w.translation} data-id="element-198" data-mp="1eedccn25v28y">
                {w.term}
              </li>)}
          </ul>
        </div>}

      <div className="mt-5" data-id="element-199" data-mp="225iqmxsgdmh5">
        <BrutalButton to={practicePath(course)} variant="surface" size="sm" full disabled={due.length === 0} data-id="element-200" data-mp="224r3mbcx8x2h">
          Practise {Math.min(due.length, 10)} due words
        </BrutalButton>
      </div>
    </section>;
}